export default __webpack_public_path__ + "static/banner_bg-fa1b3688eb1192930ca81e502ac18f63.webp";